import { Modal, Row, Col, Button } from "antd";
import React from "react";
import { COLORS } from "../../../../config/theme";

const AlertModal = ({ adminId, setAdminId, handleAddAdminCards }) => {
  const { primaryDark } = COLORS;
  return (
    <Modal
      title="Admin Already Exists"
      visible={!!adminId}
      footer={null}
      onCancel={() => setAdminId("")}
      centered
    >
      <Row
        span={24}
        style={{
          display: "flex",
          justifyContent: "center",
          textAlign: "center",
        }}
      >
        <p>Admin with this email already exists !</p>
      </Row>
      <Row span={24} style={{ textAlign: "center" }}>
        <p>
          Do you want to add these cards into admin wave cards list and increase
          the allowed card count?
        </p>
      </Row>
      <Row span={24}>
        <Col span={12} style={{ display: "flex", justifyContent: "center" }}>
          <Button
            shape="round"
            type="primary"
            style={{
              background: primaryDark,
              borderColor: primaryDark,
              marginTop: "2rem",
              width: "5rem",
            }}
            onClick={() => {
              setAdminId("");
            }}
          >
            No
          </Button>
        </Col>
        <Col span={12} style={{ display: "flex", justifyContent: "center" }}>
          <Button
            shape="round"
            type="primary"
            style={{
              background: primaryDark,
              borderColor: primaryDark,
              marginTop: "2rem",
              width: "5rem",
            }}
            onClick={() => {
              handleAddAdminCards();
            }}
          >
            Yes
          </Button>
        </Col>
      </Row>
    </Modal>
  );
};
export default AlertModal;
